import type {
  Follow,
  DeviceSettings,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { createContext } from "react"
import { defaultDeviceSettings } from "src/hooks/deviceSettings/defaultDeviceSettings"
import { defaultFollow } from "src/hooks/follows/defaultFollow"

export type FollowedUsersContextValue = {
  currentUserId: Follow["following_account_id"] | undefined;
  follows: Follow[];
  selfFollow: Follow;
  currentFollow: Follow;
  currentDeviceSettings: DeviceSettings;
  isFollowOnlyWithNoFollows: boolean;
  isLoading: boolean;
}

export const FollowedUsersContext = createContext<FollowedUsersContextValue>({
  currentUserId: undefined,
  follows: [],
  selfFollow: defaultFollow,
  currentFollow: defaultFollow,
  currentDeviceSettings: defaultDeviceSettings,
  isFollowOnlyWithNoFollows: false,
  isLoading: false,
})
